import type { SceneQuality } from "../scene/SceneCanvas";

export function StatusNotice({
  quality,
}: {
  readonly quality: SceneQuality | null;
}) {
  if (quality !== "reduced") {
    return null;
  }

  return (
    <p className="status-notice" role="status">
      Reduced 3D quality is active to keep the simulation responsive
    </p>
  );
}
